import LocationForm from '@app/components/apps/Locations/LocationForm';
import { BaseBreadcrumb, BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { Col, Row } from 'antd';
import { useEffect, useState } from 'react';

const routes = [
  {
    path: '/locations',
    breadcrumbName: 'Locations',
  },
  {
    path: '/add-location',
    breadcrumbName: 'Add Location',
  },
];

const CreateLocationPage = () => {
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Add Product Category');

  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);

  return (
    <Row gutter={[16, 16]}>
      <LocationForm
        editable={true}
        pageTitle={'Create Location'}
        type={'create'}
        setCurrentBreadcrumName={setCurrentBreadcrumName}
      />
    </Row>
  );
};

export default CreateLocationPage;
